export const GET_NEWSLETTERS = "GET_NEWSLETTERS";
export const FILTER_NEWSLETTERS = "FILTER_NEWSLETTERS";
export const ADD_NEWSLETTER = "ADD_NEWSLETTER";
export const EDIT_NEWSLETTER = "EDIT_NEWSLETTER";
export const GET_NEWSLETTER = "GET_NEWSLETTER";
export const RESET_NEWSLETTER = "RESET_NEWSLETTER";
export const NEWSLETTERS_ERROR = "NEWSLETTERS_ERROR";
